import React, { Component } from 'react';
import { connect } from 'react-redux';

let mapStateToProps = (state, ownProps) => {
    return {
        categories: state.categories.categoriesList
    }
};

class CategoryList extends Component {
    render() {
        let categoriesList = this.props.categories.map((category, i) => {
            return (
                <div key={`categoriesList-${i}`} className="row activityItem">
                    <div className="col-sm-3 col-xs-12 acvitiy-title">
                        <p className="itemId">{category.name}</p>
                    </div>
                    <div className="col-sm-6 col-xs-12 activity-desc">
                        <p className="desc">{category.desc}</p>
                    </div>
                    <div className="col-sm-3 col-xs-12 itemButton">
                        <button
                            onClick={() => this.props.onSelectItem(category)}
                            className="btn-submit"
                        >Select Activity</button>
                    </div>
                </div>
            );
        });

        return (
            <div className="searchSelectList">
                <div className="searchListResultWrapper">
                    <div className="container-fluid">
                        {categoriesList}
                    </div>
                </div>
            </div>
        );
    }
}
export default connect(mapStateToProps)(CategoryList);



// WEBPACK FOOTER //
// ./app/components/History/CategoryList.jsx